import type { AnalyticsUpdateBody } from "../../../../page-controller-mod/page-serv/settings/analytic-set/ts/setting-analytic.type";
import { SettingChange } from "./settings-draft.context";

export const buildAnalyticsPayload = (changes: SettingChange[]): AnalyticsUpdateBody => { //NOSONAR
  const body: AnalyticsUpdateBody = {};
  const ensure = {
    widget: /* istanbul ignore next */ () => /* istanbul ignore next */(body.widget ??= {}),
    content: () => ((body.widget ??= {}).content ??= {}), //NOSONAR
    media: () => ((body.widget ??= {}).media ??= {}), //NOSONAR
    jobApplication: () => ((body.widget ??= {}).jobApplication ??= {}), //NOSONAR
    inbox: () => ((body.widget ??= {}).inbox ??= {}), //NOSONAR
  };

  for (const c of changes) { //NOSONAR
    if (c.pageKey !== "analytics") continue; //NOSONAR
    if (c.type !== "toggle") continue; //NOSONAR

    const v = Boolean(c.value);

    if (c.groupId === 1 && c.itemId === 1) ensure.content().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 2) ensure.media().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 3) ensure.jobApplication().enabled = v; //NOSONAR
    if (c.groupId === 1 && c.itemId === 4) ensure.inbox().enabled = v; //NOSONAR
  }

  return body;
};